var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTargetIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "58px",
    height: "59px",
    viewBox: "0 0 58 59",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 68") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "91.8760557%",
    y1: "83.7378561%",
    x2: "7.54328547%",
    y2: "83.7378561%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#62EBB9",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2CB5D6",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "82.8511019%",
    y1: "11.6252134%",
    x2: "11.6739502%",
    y2: "82.2860322%",
    id: "linearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#62EBB9",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2CB5D6",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "100%",
    x2: "50%",
    y2: "0%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAEAEA",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M49.0115231,8.98865604 C37.8720603,-2.15104564 19.8109998,-2.15104564 8.671537,8.98865604 C-2.46792581,20.128093 -2.46792581,38.1888469 8.671537,49.3282839 C19.8109998,60.4679855 37.8720603,60.4679855 49.0115231,49.3282839 C60.1509859,38.1888469 60.1509859,20.128093 49.0115231,8.98865604 Z",
    id: "path-4"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-7.9%",
    y: "-7.9%",
    width: "115.8%",
    height: "115.8%",
    filterUnits: "objectBoundingBox",
    id: "filter-5"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    in: "SourceAlpha",
    result: "shadowBlurInner1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: -4,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.35 0",
    type: "matrix",
    in: "shadowInnerInner1",
    result: "shadowMatrixInner1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    in: "SourceAlpha",
    result: "shadowBlurInner2"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "shadowBlurInner2",
    result: "shadowOffsetInner2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner2",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner2"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 0.5 0",
    type: "matrix",
    in: "shadowInnerInner2",
    result: "shadowMatrixInner2"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixInner1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixInner2"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "1.89341619%",
    y1: "2.49931977%",
    x2: "81.8140687%",
    y2: "81.4224244%",
    id: "linearGradient-6"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    stopOpacity: 0.347956731,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "55.1306103%",
    y1: "53.1624762%",
    x2: "48.1932705%",
    y2: "46.2124614%",
    id: "linearGradient-7"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A5A5A",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#969696",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "HH---Financial-Results",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "HH---Results-AA-Copy-4",
    transform: "translate(-87.000000, -644.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(73.696721, 586.954161)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-68",
    transform: "translate(13.311475, 57.683060)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.0115231,8.98865604 C37.8720603,-2.15104564 19.8109998,-2.15104564 8.671537,8.98865604 C-2.46792581,20.128093 -2.46792581,38.1888469 8.671537,49.3282839 C19.8109998,60.4679855 37.8720603,60.4679855 49.0115231,49.3282839 C60.1509859,38.1888469 60.1509859,20.128093 49.0115231,8.98865604",
    id: "Fill-1",
    fill: "url(#linearGradient-1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.0115231,8.98865604 C37.8720603,-2.15104564 19.8109998,-2.15104564 8.671537,8.98865604 C-2.46792581,20.128093 -2.46792581,38.1888469 8.671537,49.3282839 C19.8109998,60.4679855 37.8720603,60.4679855 49.0115231,49.3282839 C60.1509859,38.1888469 60.1509859,20.128093 49.0115231,8.98865604 Z",
    id: "Stroke-3",
    fill: "url(#linearGradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.6111903,13.0224908 C36.6995997,4.11090016 22.2510213,4.11090016 13.3394307,13.0224908 C4.42784005,21.9340814 4.42784005,36.3829247 13.3394307,45.2942504 C22.2510213,54.206106 36.6995997,54.206106 45.6111903,45.2942504 C54.5230459,36.3829247 54.5230459,21.9340814 45.6111903,13.0224908",
    id: "Fill-5",
    fill: "url(#linearGradient-1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.6111903,13.0224908 C36.6995997,4.11090016 22.2510213,4.11090016 13.3394307,13.0224908 C4.42784005,21.9340814 4.42784005,36.3829247 13.3394307,45.2942504 C22.2510213,54.206106 36.6995997,54.206106 45.6111903,45.2942504 C54.5230459,36.3829247 54.5230459,21.9340814 45.6111903,13.0224908 Z",
    id: "Stroke-7",
    fill: "url(#linearGradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5773848,17.0564853 C34.8934138,10.3727927 24.0570741,10.3727927 17.3736339,17.0564853 C10.689663,23.7401779 10.689663,34.576762 17.3736339,41.2604546 C24.0570741,47.9441472 34.8934138,47.9441472 41.5773848,41.2604546 C48.2610903,34.576762 48.2610903,23.7401779 41.5773848,17.0564853",
    id: "Fill-9",
    fill: "url(#linearGradient-1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5773848,17.0564853 C34.8934138,10.3727927 24.0570741,10.3727927 17.3736339,17.0564853 C10.689663,23.7401779 10.689663,34.576762 17.3736339,41.2604546 C24.0570741,47.9441472 34.8934138,47.9441472 41.5773848,41.2604546 C48.2610903,34.576762 48.2610903,23.7401779 41.5773848,17.0564853 Z",
    id: "Stroke-11",
    fill: "url(#linearGradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.543361,21.0905188 C33.0877807,16.6346722 25.8633718,16.6346722 21.407259,21.0905188 C16.9516787,25.5463653 16.9516787,32.7707743 21.407259,37.2266208 C25.8633718,41.6822011 33.0877807,41.6822011 37.543361,37.2266208 C41.9992075,32.7707743 41.9992075,25.5463653 37.543361,21.0905188",
    id: "Fill-13",
    fill: "url(#linearGradient-1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.543361,21.0905188 C33.0877807,16.6346722 25.8633718,16.6346722 21.407259,21.0905188 C16.9516787,25.5463653 16.9516787,32.7707743 21.407259,37.2266208 C25.8633718,41.6822011 33.0877807,41.6822011 37.543361,37.2266208 C41.9992075,32.7707743 41.9992075,25.5463653 37.543361,21.0905188 Z",
    id: "Stroke-15",
    fill: "url(#linearGradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5095579,25.1245038 C31.2815958,22.8965679 27.6691566,22.8965679 25.4414634,25.1245038 C23.2135013,27.3524397 23.2135013,30.9645674 25.4414634,33.1922344 C27.6691566,35.4204392 31.2815958,35.4204392 33.5095579,33.1922344 C35.7372512,30.9645674 35.7372512,27.3524397 33.5095579,25.1245038",
    id: "Fill-17",
    fill: "url(#linearGradient-1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5095579,25.1245038 C31.2815958,22.8965679 27.6691566,22.8965679 25.4414634,25.1245038 C23.2135013,27.3524397 23.2135013,30.9645674 25.4414634,33.1922344 C27.6691566,35.4204392 31.2815958,35.4204392 33.5095579,33.1922344 C35.7372512,30.9645674 35.7372512,27.3524397 33.5095579,25.1245038 Z",
    id: "Stroke-19",
    fill: "url(#linearGradient-2)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Stroke-3",
    fill: "black",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("use", {
    filter: "url(#filter-5)",
    xlinkHref: "#path-4"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M28.0758176,28.3929348 C28.7452136,27.7233023 29.8304969,27.7233023 30.5001297,28.3929348 L30.5001297,28.3929348 L41.7287705,39.6217104 L48.1519717,39.6225941 L58,49.4706185 L51.5767705,49.4697104 L52.4869978,50.3797944 C53.1170176,51.009814 53.1540776,52.0082317 52.5981778,52.6815923 L52.4869978,52.8038688 C51.8176017,53.4732646 50.7323185,53.4732646 50.0629224,52.8038688 L50.0629224,52.8038688 L49.1527705,51.8937104 L49.1536752,58.3169399 L39.3056469,48.4689155 L39.3047705,42.0457104 L28.0758176,30.8167725 C27.4457977,30.1869757 27.4087377,29.1885711 27.9646376,28.5152113 Z",
    id: "Combined-Shape",
    fill: "url(#linearGradient-6)"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-69",
    fill: "#646464",
    points: "38.9836066 9.82457805 38.9836066 16.4808743 49.1256831 6.65629627 49.1256831 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-73",
    fill: "#646464",
    points: "47.5414014 19.0163934 40.8852459 19.0163934 50.7097286 8.87431694 57.3661202 8.87431694"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.4155801,7.42934355 C53.100089,6.74483462 53.100089,5.6350491 52.4155801,4.95054017 C51.7310711,4.26603124 50.6212856,4.26603124 49.9367767,4.95054017 L27.4532724,27.4340444 C26.7687635,28.1185534 26.7687635,29.2283389 27.4532724,29.9128478 C28.1377813,30.5973567 29.2475669,30.5973567 29.9320758,29.9128478 L52.4155801,7.42934355 Z",
    id: "Fill-77",
    fill: "url(#linearGradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.6820978,26.1166145 C45.7869546,26.2646191 46.0032322,26.3073239 46.1651912,26.212016 C46.3271332,26.1166925 46.3734388,25.9194537 46.2685821,25.7714491 L34.2539599,8.04125213 C34.1491202,7.89324753 33.9328255,7.85054276 33.7708835,7.94585067 C33.6089246,8.0411741 33.562636,8.23841294 33.6674757,8.38641754 L45.6820978,26.1166145 Z",
    id: "Stroke-63-Copy",
    fill: "#FFFFFF",
    opacity: 0.102893,
    transform: "translate(39.968033, 17.078933) rotate(-101.000000) translate(-39.968033, -17.078933) "
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#000000",
    opacity: 0.168838356,
    transform: "translate(51.376260, 6.570487) rotate(-45.000000) translate(-51.376260, -6.570487) ",
    cx: 51.3762601,
    cy: 6.5704869,
    rx: 1,
    ry: 1.15047655
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTargetIcon);
export default __webpack_public_path__ + "static/media/target-icon.30a0ce2e87b225a0e4c1635c30f4997c.svg";
export { ForwardRef as ReactComponent };